// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c6bfd9ee","239":"46a6835b","453":"87837730","732":"372f3838"}[chunkId] + ".chunk.js";
};